import { post } from './fetch';

const integrationsOptions = {
  All: true,
  'Google Analytics': false,
  'Google Analytics 4': false,
  'Vero': false
};

const trackPage = (name, opts = {}) => {
  // disable page view data from being sent to Google Ads & Analytics
  const integrations = {
    integrations: {
      ...opts.integrations,
      ...integrationsOptions
    }
  };
  if (window.rudderanalytics && window.rudderanalytics.page) {
    window.rudderanalytics.page(name, {}, { ...integrations, ...opts });
  }
  try {
    post('/binoculars', {
      event: name,
      type: 'page',
      properties: opts
    });
  } catch (error) {
    console.error('Error sending page event to /binoculars:', error);
  }
};

const trackFacebook = name => {
  const officialFBEvents = ['StartTrial']; // add any of the defautl FB events we use here.
  const interval = setInterval(() => {
    // set interval to try and fire event until window.fbq is defined
    if (window.fbq) {
      if (officialFBEvents.includes(name)) {
        window.fbq('track', name);
      } else {
        window.fbq('trackCustom', name);
      }
      clearInterval(interval);
    }
  }, 100);
};

const trackGA = event => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

export { trackPage, trackFacebook, trackGA };

const track = (name, properties = {}, options = {}, domain = '') => {
  const integrations = {
    integrations: {
      ...options.integrations,
      ...integrationsOptions
    }
  };
  if (window.rudderanalytics?.track) {
    window.rudderanalytics.track(name, properties, {
      ...integrations,
      ...options
    });
  } else {
    console.log('attempted to track via rudderstack', name, properties, {
      ...integrations,
      ...options
    });
  }
  try {
    post(`${domain}/binoculars`, {
      event: name,
      properties: properties
    });
  } catch (error) {
    console.error(`Error sending track event to ${domain}/binoculars:`, error);
  }
};

export default track;
export const ONBOARDING_CREATE_PROJECT = 'Onboarding Create Project';
export const ONBOARDING_COMPLETE = 'Onboarding Complete';
export const ONBOARDING_DO_THIS_LATER = 'Onboarding Do this later link clicked';
export const ONBOARDING_USE_EXAMPLE_DATA =
  'Onboarding Use Example Data link clicked';
